import { Route } from "react-router";
import SeasonListPage from "../pages/list/season-list.page";
import { seasonsPathPatterns } from "./seasons-path-patterns";

export const seasonsRoutes = [
  <Route key="seasons-list" path={seasonsPathPatterns.list} element={<SeasonListPage />} />,
];
